export class HotelDetails {
  static empty() {
    return new HotelDetails()
  }

  constructor() {
    this.loading = true
    this.coBrandImage = {}

    this.hotel = {
      address: {},
      image: {}
    }
  }
}

export class BookingSummary {
  static empty() {
    return new BookingSummary()
  }

  constructor() {
    this.loading = true
    this.customer = {}
    this.priceSummary = {
      totalWithTax: {},
      totalTaxAndFees: {}
    }

    this.stay = {
      rate: {
        conditions: {
          features: [],
          instructions: [],
          guaranteePolicies: [],
          cancellationPoliciesExtended: {
            policies: []
          }
        }
      },
      occupancy: {}
    }

    this.guaranteeType = {}
    this.rooms = []
  }
}
